module.exports = require("skypager-registry");


//////////////////
// WEBPACK FOOTER
// external "skypager-registry"
// module id = 112
// module chunks = 0 1 2